import { storeToRefs } from 'pinia'
import { onMounted, watch } from 'vue'
import useAuthStore from '@/modules/Auth/store'
import useUserStore from '@/modules/User/store'

export function useCurrentEmployeeProfile() {
  const authStore = useAuthStore()
  const userStore = useUserStore()

  const { profile, status, fullName, positionTitle, isActive, employeeId } =
    storeToRefs(userStore)

  function loadIfAuthenticated() {
    if (authStore.isAuthenticated) {
      void userStore.ensureProfile()
    }
  }

  onMounted(loadIfAuthenticated)

  watch(
    () => authStore.isAuthenticated,
    (isAuthenticated) => {
      if (isAuthenticated) {
        void userStore.ensureProfile()
        return
      }

      userStore.clearProfile()
    }
  )

  return {
    profile,
    status,
    fullName,
    positionTitle,
    isActive,
    employeeId,
    ensureProfile: userStore.ensureProfile,
    refreshProfile: userStore.refreshProfile,
  }
}
